import React, { Fragment } from 'react'
import { Badge, ButtonGroup, Card, CardBody, Col, Container, FormGroup, Input, Label, Pagination, Row, Table } from 'reactstrap'
import { useViewInvoice } from '../../hooks/invoice/useViewInvoice';
import { ModalCancelInvoice } from '../../components/Invoice/ModalCancelInvoice';
import { ModalCancelPreInvoice } from '../../components/Invoice/ModalCancelPreInvoice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';






export const IndexViewInvoice = () => {

    const {
        listbranch,
        //#region RETURN GLOBAL VARIABLES
        loading, method,
        //#endregion

        //#region MODALS
        modalTitle, modalCancellation, toggleModalCancellation,
        //#endregion

        //#region RETURN VIEW INVOICE
        // RETURN MODELS
        informationInvoice, ListInvoices, ListTypeCancellations,

        id_invoice, code_type_cancellation, code_reference_value, is_general_public,

        handleInputChange,

        //RETURN FILTERS
        iTypeDocument, iTypePayMethod, iDateIni, iDateEnd, iBranch,

        handleInputChangeFilters,

        //RETURN HANDLE METHODS
        SaveCancellationInvoice,
        handleFilters,

        //RETURN PAGINATION
        actualPage, goToPage,
        totalRecords, isgeneral_public,

        // ? CONFIGURATION PRE INVOICE
        preInvoice, tooglePreInvoice, modalPre, saveCancelInvoice,

        // ? CONFIGURATION DATATABLE
        fechaFolioTag, receptorInvoice, typeDocumentTag, actionBodyTemplate, actionPayed, actionIsEnvelopeOpen, actionDownloadPdf,
        actionDownloadXml, actionDownloadSupport, actionStatusInvoice, actionInvoiceOptions, dataLoading,
        iFolio, iRfc, allBranch, handleTypeCompany, resultCount,
        handleInputChangeFilters2, loadingReport, downdloadExcel,
        message, handleClosedMessage


        //#endregion 



    } = useViewInvoice();


    // ? CONFIGURATION DATATABLE
    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle =
    {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2, border: "1px solid #cccccc9c",
        borderCollapse: "collapse"
    };

    const rowsPerPage = 10

    // ? END CONFIGURATION DATATABLE



    return (
        <Fragment>
            <Container fluid={true}  className='container-global-zoom' >
                    <Col sm="12" className='p-l-0 p-r-0' >
                        <Card style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                            <Col sm="12" className='pt-2 pb-2' >
                                <Row>
                                    <Col sm="2">
                                        <FormGroup>
                                            <Label type="text" className='form-col-label txt-secondary'>Fecha de inicio</Label>
                                            <Input type='date' value={iDateIni} name='iDateIni' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='YYYY-MM-DD' />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="2">
                                        <FormGroup>
                                            <Label className='form-col-label txt-secondary'>Fecha de cierre</Label>
                                            <Input type='date' value={iDateEnd} name="iDateEnd" onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='YYYY-MM-DD' />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="2">
                                        <FormGroup>
                                            <Label className='txt-secondary'>Sucursal</Label>
                                            <Input
                                                type='select'
                                                value={iBranch}
                                                name='iBranch'
                                                onChange={(e) => handleInputChangeFilters2(e)}
                                                className='form-control form-control-sm input-air-primary b-r-9'
                                                placeholder='Sucursal'
                                            >
                                                <option value="0">Selecciona una opción</option>
                                                <option value="0">Todas las sucursales</option>
                                                {listbranch.length > 0 && listbranch.map((s, key) => (
                                                    <option key={key} value={s.id_branch}>
                                                        {s.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="2">
                                        <FormGroup>
                                            <Label className='txt-secondary'>Tipo de comprobante</Label>
                                            <Input type="select" value={iTypeDocument} name='iTypeDocument' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Tipo de comprobante'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="I">Ingreso (Factura)</option>
                                                <option value="E">Egreso (Nota de crédito)</option>
                                                <option value="P">Pago (Complemento de pago)</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>


                                    <Col sm="2">
                                        <FormGroup>
                                            <Label className='txt-secondary'>Método de pago</Label>
                                            <Input type='select' value={iTypePayMethod} name='iTypePayMethod' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Método de pago'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="PUE">PUE</option>
                                                <option value="PPD">PPD</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="2" >
                                        <FormGroup>
                                            <Label className='txt-secondary'>Publico General</Label>
                                            <Input type="select" value={isgeneral_public} name='isgeneral_public' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Tipo de comprobante'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="true">Factura Global</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="7">
                                    </Col>
                                    <Col sm="2" className="p-r-0 d-flex align-items-end" >
                                        <label >Mostrando {actualPage} a {resultCount} de {totalRecords} resultados</label>
                                    </Col>
                                    <Col sm="1" className='d-flex align-items-end p-l-0 p-r-0' >
                                        <Input type='text' value={iRfc} name="iRfc" onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='RFC - Razón social' />
                                    </Col>
                                    <Col sm="1" className='d-flex align-items-end p-r-0' >
                                        <Input type='text' value={iFolio} name='iFolio' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Folio' />
                                    </Col>
                                    <Col sm="1" className="d-flex justify-content-start align-items-end" style={{ gap: "6px" }}>
                                        <Button
                                            disabled={dataLoading}
                                            severity="success"
                                            onClick={() => handleFilters()}
                                            style={{
                                                padding: "5px 10px",
                                                height: "35px",
                                                fontSize: "0.7rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "6px"
                                            }}
                                        >
                                            {!dataLoading && <i className="pi pi-search" />}
                                            {dataLoading ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} />
                                                    Buscando...
                                                </>
                                            ) : null}
                                        </Button>
                                        <Button
                                            disabled={loadingReport}
                                            onClick={() => downdloadExcel()}
                                            style={{
                                                padding: "5px 10px",
                                                height: "35px",
                                                fontSize: "0.7rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "6px",
                                                backgroundColor: loadingReport ? '#B0BEC5' : '#4CAF50',
                                                borderColor: loadingReport ? '#B0BEC5' : '#4CAF50',
                                                color: loadingReport ? '#fff' : '#fff',
                                                cursor: loadingReport ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            {!loadingReport && <i className="pi pi-file-excel" style={{ fontSize: "1rem" }} />}
                                            {loadingReport ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} />
                                                    Descargando...
                                                </>
                                            ) : null}
                                        </Button>


                                    </Col>
                                </Row>
                            </Col>
                        </Card>
                    </Col>
                    <Col sm="12" md="12" lg="12" className='p-l-0 p-r-0' >
                        <DataTable
                            value={ListInvoices}
                            loading={dataLoading}
                            lazy
                            paginator
                            first={(actualPage - 1) * rowsPerPage}
                            rows={rowsPerPage}
                            totalRecords={totalRecords}
                            onPage={(e) => goToPage(e.page + 1)}
                            className="data-table p-datatable-striped p-datatable-sm"
                            responsiveLayout="scroll"
                            emptyMessage={
                                <div className="text-center">
                                    <img
                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "32%" }}
                                        alt="Sin resultados"
                                    />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>No se encontraron resultados.</p>
                                </div>
                            }
                        >
                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                            <Column
                                header="Serie/Folio"
                                body={(row) => fechaFolioTag(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column
                                header="Receptor"
                                body={(row) => receptorInvoice(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column field="uuid" header="UUID" headerStyle={headerStyle} style={centerStyle} />
                            <Column field="dateCreated" header="Fecha" headerStyle={headerStyle} style={centerStyle} />
                            <Column field="codeCoin" header="Moneda" headerStyle={headerStyle} style={centerStyle} />
                            <Column field="total" header="Monto" headerStyle={headerStyle} style={centerStyle} />
                            <Column
                                header="Tipo"
                                body={(row) => typeDocumentTag(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column
                                header={<i className="icofont icofont-send-mail f-24 text-warning"></i>}
                                body={(row) => actionBodyTemplate(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column
                                header={<i className="icofont icofont-coins f-18 text-success"></i>}
                                body={(row) => actionPayed(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column
                                header={<i className="icofont icofont-envelope-open f-18 text-info"></i>}
                                body={(row) => actionIsEnvelopeOpen(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />

                            <Column
                                header={<i className="icofont icofont-file-pdf f-18 text-info"></i>}
                                body={(row) => actionDownloadPdf(row)}
                                headerStyle={headerStyle}
                                style={centerStyle}
                            />
                            <Column
                                header={<i className="fa fa-file-code-o f-18 text-info"></i>}
                                body={(rowData) => actionDownloadXml(rowData)}
                                style={centerStyle}
                                headerStyle={headerStyle}

                            />
                            <Column
                                header={<i className="fa fa-file-text f-18" style={{ color: "#f73d6d" }}></i>}
                                body={(rowData) => actionDownloadSupport(rowData)}
                                style={centerStyle}
                                headerStyle={headerStyle}

                            />
                            <Column
                                header="Estado"
                                body={(rowData) => actionStatusInvoice(rowData)}
                                style={centerStyle}
                                headerStyle={headerStyle}

                            />
                            <Column
                                header="Acciones"
                                body={(rowData) => actionInvoiceOptions(rowData)}
                                style={centerStyle}
                                headerStyle={headerStyle}
                            />
                        </DataTable>
                    </Col>
            </Container>
            <ModalCancelInvoice
                {
                ...{
                    modalTitle, modalCancellation, toggleModalCancellation,
                    loading, method,

                    informationInvoice, ListTypeCancellations,
                    id_invoice, code_type_cancellation, code_reference_value, is_general_public,
                    handleInputChange, SaveCancellationInvoice,
                    message, handleClosedMessage

                }
                }
            />
            <ModalCancelPreInvoice
                {
                ...{
                    preInvoice, tooglePreInvoice, modalPre, saveCancelInvoice
                }
                }
            />

        </Fragment>
    )
}